"use client"

import { ItemPageType } from "@/app/navigation/item"
import type { NftId } from "@anaconda/core/nft/types"
import { Trans } from "@lingui/react/macro"
import { NavigationTabsList } from "@rarible_int/anaconda_ui_components"
import { NftPageLink } from "./link"

interface Props {
  nftId: NftId
}

export function ItemNavigation(props: Props) {
  return (
    <NavigationTabsList variant="tabs" className="border-b">
      <NftPageLink nftId={props.nftId} pageType={ItemPageType.OVERVIEW}>
        <Trans>Overview</Trans>
      </NftPageLink>
      <NftPageLink nftId={props.nftId} pageType={ItemPageType.OFFERS}>
        <Trans>Offers</Trans>
      </NftPageLink>
      <NftPageLink nftId={props.nftId} pageType={ItemPageType.ACTIVITY}>
        <Trans>Activity</Trans>
      </NftPageLink>
    </NavigationTabsList>
  )
}
